import React, { useEffect, useState } from 'react';
import Card from '../../../components/SuperAdminComponents/Card';
import BarChart from '../../../components/SuperAdminComponents/BarChart';
import TotalDonations from '../../../components/SuperAdminComponents/TotalDonations';
import Donations from '../../../components/SuperAdminComponents/Donations';

//SVG ICONS
import Contributers from '../../../Icons/contributers.svg';
import Orgs from '../../../Icons/orgs.svg';
import Projects from '../../../Icons/projects.svg';
import Money from '../../../Icons/si-glyph_money-coin.svg';

import { getDashboardHeaders, getDonationsPerOrg, getDonationsPerProject, numberWithCommas } from "../../../global/helpers";

export default function Stats() {

  const [totalContribs, setTotalContribs] = useState("");
  const [totalOrg, setTotalOrg] = useState("");
  const [totalProjects, setTotalProjects] = useState("");
  const [totalOrgsDonationsAmount, setTotalOrgsDonationsAmount] = useState("");
  const [totalProjectsDonationsAmount, setTotalProjectsDonationsAmount] = useState("");

  const [donationsPerOrganization, setDonationsPerOrganization] = useState([]);
  const [donationsPerProjects, setDonationsPerProjects] = useState([]);
  const [isFinishedPerOrg, setIsFinishedPerOrg] = useState(false);
  const [isFinishedPerProject, setIsFinishedPerProject] = useState(false);

  useEffect(() => {
    getDashboardHeaders().then((response) => {
      if (response !== undefined) {
        if (response.status === 200) {
          let dashboardHeaders = response?.data
          setTotalContribs(numberWithCommas(dashboardHeaders?.totalContribs))
          setTotalOrg(numberWithCommas(dashboardHeaders?.totalOrg))
          setTotalProjects(numberWithCommas(dashboardHeaders?.totalProjects))
          setTotalOrgsDonationsAmount(numberWithCommas(dashboardHeaders?.totalOrgsDonationsAmount))
          setTotalProjectsDonationsAmount(numberWithCommas(dashboardHeaders?.totalProjectsDonationsAmount))
        }
      }
    })

    getDonationsPerOrg().then((response) => {
      if (response !== undefined) {
        if (response.status === 200) {
          let data = response?.data
          setDonationsPerOrganization(data)
          setIsFinishedPerOrg(true)

        }
      }
    })

    getDonationsPerProject().then((response) => {
      if (response !== undefined) {
        if (response.status === 200) {
          let data = response?.data
          setDonationsPerProjects(data)
          setIsFinishedPerProject(true)
        }
      }
    })
  }, [])

  return (
    <div className='container-fluid'>
      <div className='d-lg-flex d-md-block'>
        <div className='d-md-block'>
          <Card title='Contributors' total={totalContribs} icon={Contributers} />
          <Card title='Organizations' total={totalOrg} icon={Orgs} />
          <Card title='Projects' total={totalProjects} icon={Projects} />
        </div>
        <div className='ml-lg-5 ml-md-0 w-100' >
          <BarChart />
        </div>
      </div>
      <div className='d-lg-flex justify-content-lg-between '>
        <TotalDonations amount={totalOrgsDonationsAmount} title='Total Organizations Donations' icon={Money} />
        <TotalDonations amount={totalProjectsDonationsAmount} title='Total Projects Donations' icon={Money} />
      </div>
      <div className='d-lg-flex justify-content-lg-between d-md-block '>
        <Donations
          title='Donations per organization'
          isDonationPerOrg={true}
          data={donationsPerOrganization}
          isFinished={isFinishedPerOrg}
          donationsPerProjects={donationsPerProjects}
        />
        <Donations
          title='Donations per Project'
          isDonationPerOrg={false}
          data={donationsPerProjects}
          isFinished={isFinishedPerProject} />
      </div>
    </div>
  );
}
